export const CLEMENTINE_ROLES = Object.freeze([
  {
    value: 'Owner / President & Compliance Officer',
    shortLabel: 'Owner / President & Compliance Officer',
    description: 'Executive oversight, compliance leadership, access approvals, privacy decisions, and incident escalation.',
  },
  {
    value: 'Credentialing / Provider Enrollment',
    shortLabel: 'Credentialing',
    description: 'Provider enrollment, licenses, payer portals, and sensitive credentialing records.',
  },
  {
    value: 'BCBA / Clinical Supervisor',
    shortLabel: 'BCBA',
    description: 'Assigned client records, treatment plans, clinical documentation, and staff supervision.',
  },
  {
    value: 'Family Coordinator / Intake & Scheduling',
    shortLabel: 'Family Coordinator',
    description: 'Family intake, insurance information, scheduling, authorizations, and family communication.',
  },
  {
    value: 'Support / Administrative Staff',
    shortLabel: 'Support Staff',
    description: 'Administrative support using only the patient or employee information needed for assigned work.',
  },
  {
    value: 'RBT / Behavior Technician',
    shortLabel: 'RBT / Behavior Technician',
    description: 'Direct services and session data for assigned clients under BCBA supervision.',
  },
]);

export function roleDescription(role) {
  return CLEMENTINE_ROLES.find(item => item.value === role)?.description || '';
}
